import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Container,
  Grid,
  makeStyles,
  Typography
} from "@material-ui/core";
import {
  LogoGGT,
  ChatTeaser,
  LanguageToggle,
  LogoVaxYes
} from "../../components";
import { useLanguages } from "../../contexts";
import { BrandThemeContext } from "../../contexts/BrandThemeProvider";
import * as queryString from "query-string";
import { useLocation } from "react-router";
import { PARTNERS } from "../../constants";

const useClasses = makeStyles({
  grid: {
    minHeight: "100vh"
  }
});

const LoginWrapper = ({ children, showLogo = true }) => {
  const { themeName } = useContext(BrandThemeContext);
  const location = useLocation();
  const classes = useClasses();
  const { setLanguage, language } = useLanguages();
  const [partner, setPartner] = useState();

  useEffect(() => {
    if (!location || !location.search) return;

    const { partner = "" } = queryString.parse(location.search);

    if (PARTNERS[partner]) setPartner(PARTNERS[partner]);
  }, [location]);

  return (
    <>
      <Container maxWidth="xs" disableGutters>
        <Grid
          container
          direction="column"
          justify="center"
          className={classes.grid}
        >
          {showLogo && (
            <Grid item xs={12}>
              <Box mb={2}>
                <Typography align="center" gutterBottom>
                  {themeName === "GGT" && <LogoGGT />}
                  {themeName === "GGV" && <LogoVaxYes height="55px" />}
                </Typography>
              </Box>
              {partner && (
                <Box mb={2}>
                  <Grid
                    container
                    spacing={1}
                    alignItems="center"
                    justify="center"
                  >
                    <Grid item>
                      <Typography style={{ fontSize: "13px" }}>
                        In partnership with
                      </Typography>
                    </Grid>
                    <Grid item>{partner.logo("20px")}</Grid>
                  </Grid>
                </Box>
              )}
            </Grid>
          )}
          <Grid item xs={12}>
            {children}
            <Box px={2} py={1}>
              <Grid
                container
                spacing={2}
                alignItems="center"
                justify="space-between"
              >
                <Grid item xs>
                  <Box pl={1}>
                    <ChatTeaser />
                  </Box>
                </Grid>
                <Grid item>
                  <LanguageToggle
                    language={language}
                    handleToggleLanguage={(e, value) => setLanguage(value)}
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export { LoginWrapper };
